import { render, staticRenderFns } from "./AssignedPermission.vue?vue&type=template&id=73c99506&"
import script from "./AssignedPermission.vue?vue&type=script&lang=ts&"
export * from "./AssignedPermission.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports